import React from "react";
import "./header.css";

const Head = () => {
  
};

export default Head;
